<div style="display: flex; flex-direction: column; width: 100%; height: 100%">
  @if (isLoading) {
    <div
      style="flex: 1 0 100%; min-height: 0; display: flex; flex-direction: column; justify-content: space-between;">
      @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
        <sh-tabs id="autocheck-details-tabs-1" style="width: 43%" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
          >
          @for (tab of displayedTabs; track tab.name) {
            <sh-tab-item id="autocheck-details-tab-item-2" disabled [active]="activeTab === tab.name"
            (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
          }
        </sh-tabs>
      }
      <div style="flex: 1; display: flex; align-items: center; justify-content: center;">
        <sh-spinner id="autocheck-details-spinner-3" site="s"></sh-spinner>
      </div>
    </div>
  }
  <sh-popover id="autocheck-details-popover-4" target="info-icon">{{ 'autocheckDetails.popover.noAction' | transloco }}</sh-popover>
  <sh-tooltip id="autocheck-details-tooltip-5" #tooltip></sh-tooltip>
  @if (!isLoading && autocheckData) {
    <div style="flex: 1; min-height: 0;">
      @if (autocheckData && !isLoading) {
        <p-table [size]="'small'" #table [value]="autocheckData" dataKey="name"
          [expandedRowKeys]="expandedRows" [scrollable]="true" [scrollHeight]="'flex'"
          (onFilter)="onTableFilter($event)" [customSort]="true" (sortFunction)="customSort($event)"
          [sortField]="'failed'" [sortOrder]="-1">
          <!-- Tools -->
          <ng-template #caption style="border: none;">
            <div style="display: flex; align-items: center; gap: 64px;">
              @if (selectedWidget === 'instrument' || selectedWidget === 'service-history') {
                <sh-tabs id="autocheck-details-tabs-6" style="flex: 1 1 43%;" condensed [collapsed]="screenSize === 'XSmall' || screenSize === 'Small' || screenSize === 'Medium'"
                  >
                  @for (tab of displayedTabs; track tab.name) {
                    <sh-tab-item id="autocheck-details-tab-item-7" [active]="activeTab === tab.name"
                    (click)="switchTab(tab.name)" [attr.label]="tab.labelKey | transloco"></sh-tab-item>
                  }
                </sh-tabs>
              }
              <div class="table-tools" style="flex: 1 1 57%; gap: 8px; align-items: center;">
                <sh-dropdown id="autocheck-details-dropdown-8" no-border condensed style="min-width: 100px; max-width: 140px;" [attr.value]="(selectedRange === 7 ? 'errors.range.7days' : selectedRange === 14 ? 'errors.range.14days' : 'errors.range.30days') | transloco">
                  <sh-menu-item id="autocheck-details-menu-item-7-days" (click)="changeRange(7,'systemHealth')" [attr.label]="'errors.range.7days' | transloco"
                  [active]="selectedRange === 7"></sh-menu-item>
                  <sh-menu-item id="autocheck-details-menu-item-14-days" (click)="changeRange(14,'systemHealth')" [attr.label]="'errors.range.14days' | transloco"
                  [active]="selectedRange === 14"></sh-menu-item>
                  <sh-menu-item id="autocheck-details-menu-item-30-days" (click)="changeRange(30,'systemHealth')" [attr.label]="'errors.range.30days' | transloco"
                  [active]="selectedRange === 30"></sh-menu-item>
                </sh-dropdown>
                <p-columnFilter style="min-width: 150px;" type="text" [showMenu]="false" field="custom"
                  matchMode="contains">
                  <ng-template #filter let-value let-filter="filterCallback" style="width: 100%;">
                    <sh-search id="autocheck-details-search-search-for-test-name" no-border [attr.label]="'autocheckDetails.filter.searchForTestName' | transloco" condensed [(ngModel)]="searchTerm"
                    (ngModelChange)="onSearchChange($event, filter)"></sh-search>
                  </ng-template>
                </p-columnFilter>
                <sh-divider id="autocheck-details-divider-13" spacing='s' style="height: 30px;" vertical></sh-divider>
                <!-- <sh-button id="autocheck-details-button-all-charts" layout="compact" icon="analytics" icon-position="left" color="secondary"
              label="All Charts" (click)="openCharts()"></sh-button> -->
              <sh-icon id="autocheck-details-icon-analytics" icon="analytics" size="s" (click)="openCharts()" (mouseover)="showTooltip('autocheckDetails.tooltip.allCharts', $event)" button></sh-icon>
              <sh-divider id="autocheck-details-divider-16" spacing='s' style="height: 30px;" vertical></sh-divider>
              <sh-icon id="autocheck-details-icon-17" button icon='refresh' size="s" (click)="refresh()"></sh-icon>
              @if (workareaSize !== 'fullscreen') {
                <sh-icon id="autocheck-details-icon-18" size="xs" [icon]="workareaSize === 'medium' ? 'arrow-face-up-l' : 'arrow-face-down-l'"
                button (click)="onMaximize()" [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              }
              <sh-icon id="autocheck-details-icon-expand" size="s" [icon]="workareaSize === 'fullscreen' ? 'split-vertically' : 'maximize'" button (click)="onExpand($event)"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
              <sh-icon id="autocheck-details-icon-cancel" icon="cancel" size="s" button (click)="onMinimize()"
              [tabindex]="workareaSize === 'small' ? -1 : 0"></sh-icon>
            </div>
          </div>
        </ng-template>
        <!-- Table Header -->
        <ng-template pTemplate="header" let-expanded="expanded">
          <tr>
            <th pSortableColumn="name" style="min-width: 300px;">
              <div style="display: flex; align-items: center; gap: 6px;">{{ 'autocheckDetails.table.testName' | transloco }}<p-sortIcon field="name" />
              </div>
            </th>
            <th pSortableColumn="failed" style="min-width: 150px; text-align: right;">
              <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">{{ 'autocheckDetails.table.failedAndTrend' | transloco }}<p-sortIcon field="failed" />
              </div>
            </th>
            <!-- <th pSortableColumn="Failed" style="min-width: 50px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">Missed<p-sortIcon field="Failed" />
            </div>
          </th> -->
          <th pSortableColumn="passed" style="min-width: 50px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px; justify-content: flex-end;">
              {{ 'autocheckDetails.table.passed' | transloco }}<p-sortIcon field="passed" />
            </div>
          </th>
          <th pSortableColumn="last_failed_date" style="min-width: 115px; text-align: right;">
            <div style="display: flex; align-items: center; gap: 6px;">{{ 'autocheckDetails.table.lastFailed' | transloco }}<p-sortIcon
              field="last_failed_date" />
          </div>
        </th>
        <th alignFrozen="right" pFrozenColumn></th>
      </tr>
    </ng-template>
    <!-- Parent Rows -->
    <ng-template pTemplate="body" let-row let-expanded="expanded" let-index="index">
      <tr>
        <td pFrozenColumn>
          <div style="display: flex; align-items: center; gap: 8px; width: 100%;">
            <sh-icon id="autocheck-details-icon-20" [disabled]="row.name === 'Others (Click on Charts for Details)'" size="s" button [pRowToggler]="row"
              [icon]="expanded ? 'arrow-line-down-s' : 'arrow-line-right-s'">
            </sh-icon>
            <b><span [innerHTML]="highlight(row.name)"></span></b>
          </div>
        </td>
        <td style="text-align: right;">
          <div [ngClass]="{'grey-background': row.name === 'Magline'}" style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
            @if (row.name === 'Magline') {
              <sh-icon icon="information" id="info-icon" color="grey" size="xs" button></sh-icon>
            }
            @if (hasNonZeroTrend(row['failures']['failed']['trend'][selectedRange+''])) {
              <canvas baseChart class="tableChart" type="line" [data]="chartConfigs[row.name]?.data"
                [options]="chartConfigs[row.name]?.options">
              </canvas>
            }
            @if (row['failures']['failed'][selectedRange+''] !== 0) {
              <sh-badge id="autocheck-details-badge-true" [neutral]="row.name === 'Magline'"  [type]="row.name !== 'Magline' ? 'warning' : ''"
                size="medium" show-label="true"
              [label]="row['failures']['failed'][selectedRange+'']+''"></sh-badge>
            }
            @if (row['failures']['failed'][selectedRange+''] === 0) {
              <span>-</span>
            }
          </div>
        </td>
        <!-- <td style="text-align: right;">
        <div style="display: flex; justify-content: flex-end; align-items: center;">
          <sh-badge id="autocheck-details-badge-true" *ngIf="row['misses']" type='warning' size="medium" show-label="true" [label]="row['misses']['missed'][selectedRange+'']+''"
          style="background-color: #ebebeb !important"></sh-badge>
          <span *ngIf="!row['misses']">-</span>
        </div>
      </td> -->
      <td>
        <div style="display: flex; justify-content: flex-end; align-items: center;">
          @if (row?.['passed']?.[selectedRange+''] !== 0) {
            <sh-badge id="autocheck-details-badge-true" type='success' size="medium"
            show-label="true" [label]="row['passed'][selectedRange+'']+''"></sh-badge>
          }
          @if (row?.['passed']?.[selectedRange+''] === 0) {
            <span>-</span>
          }
        </div>
      </td>
      <td>{{row.date_last_failure}}</td>
      <td alignFrozen="right" pFrozenColumn>
        <div style="display: flex; gap: 8px; justify-content: flex-end; align-items: center;">
          <sh-button id="autocheck-details-button-charts" layout="compact" color="tertiary" [attr.label]="'autocheckDetails.button.charts' | transloco" (click)="openCharts(row.name === 'Others (Click on Charts for Details)' ? 'Others' : row.name)"></sh-button>
        </div>
      </td>
    </tr>
  </ng-template>
  <!-- Children Rows -->
  <ng-template #expandedrow let-expan let-expanded="expanded">
    @for (detail of expan.details; track detail.name) {
      <tr>
        <td pFrozenColumn>
          <div style="display: flex; align-items: center; gap: 8px; width: 100%; padding-left: 32px;">
            <span [innerHTML]="highlight(detail.name)"></span>
          </div>
        </td>
        <td style="text-align: right;">
          <div style="display: flex; justify-content: flex-end; align-items: center; gap: 8px;">
            @if (expan.name === 'Magline' && detail['failures']['failed'][selectedRange+''] !== 0) {
              <sh-icon icon="information" id="info-icon" color="grey" size="xs" button></sh-icon>
            }
            @if (hasNonZeroTrend(detail['failures']['failed']['trend'][selectedRange+''])) {
              <canvas baseChart class="tableChart" type="line"
                [data]="chartConfigDetails[detail.name]?.data"
                [options]="chartConfigDetails[detail.name]?.options">
              </canvas>
            }
            @if (detail['failures']['failed'][selectedRange+''] !== 0) {
              <sh-badge id="autocheck-details-badge-true" [neutral]="expan.name === 'Magline'"  [type]="expan.name !== 'Magline' ? 'warning' : ''"
                size="medium" show-label="true"
              [label]="detail['failures']['failed'][selectedRange+'']+''"></sh-badge>
            }
            @if (detail['failures']['failed'][selectedRange+''] === 0) {
              <span>-</span>
            }
          </div>
        </td>
        <!-- <td style="text-align: right;">
        <div style="display: flex; justify-content: flex-end; align-items: center;">
          <sh-badge id="autocheck-details-badge-true" *ngIf="detail['misses']" type='warning' size="medium" show-label="true" [label]="detail['misses']['missed'][selectedRange+'']+''"
          style="background-color: #ebebeb !important"></sh-badge>
          <span *ngIf="!detail['misses']">-</span>
        </div>
      </td> -->
      <td>
        <div style="display: flex; justify-content: flex-end; align-items: center;">
          @if (detail?.['passed']?.[selectedRange+''] !== 0) {
            <sh-badge id="autocheck-details-badge-true" type='success' size="medium"
            show-label="true" [label]="detail['passed'][selectedRange+'']+''"></sh-badge>
          }
          @if (detail?.['passed']?.[selectedRange+''] === 0) {
            <span>-</span>
          }
        </div>
      </td>
      <td>{{detail.date_last_failure}}</td>
      <td alignFrozen="right" pFrozenColumn>
        <div style="display: flex; gap: 8px; justify-content: flex-end; align-items: center;">
          @if (detail['failures']['failed'][selectedRange+''] > 0) {
            <sh-button id="autocheck-details-button-fix" icon-position="left"
              icon="ai-generative" [ngClass]="'magic-button'" compact [attr.label]="'autocheckDetails.button.fix' | transloco" size="s"
            color="tertiary" (click)="askChat(detail.name)"></sh-button>
          }
          @if (!businessPartnerMode && detail?.ata_link) {
            <sh-button id="ata_autocheck" [attr.label]="'autocheckDetails.button.ata' | transloco" color="tertiary" (click)="goToATA(detail.ata_link)"></sh-button>
          }
        </div>
      </td>
    </tr>
  }
</ng-template>
<ng-template pTemplate="emptymessage">
  <tr>
    <td colspan="7">
      @if (!isError) {
        <div
          style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
          <sh-icon id="autocheck-details-icon-warning" icon="warning" size="s"></sh-icon>
          <span>{{ 'common.empty.noData' | transloco }}</span>
        </div>
      }
      @if (isError) {
        <div
          style="display: flex; align-items: center; justify-content: center; gap:8px; height: 100%;">
          <sh-icon id="autocheck-details-icon-error" icon="error" size="s"></sh-icon>
          <span>{{ 'common.empty.error' | transloco }}</span>
        </div>
      }
    </td>
  </tr>
</ng-template>
</p-table>
}
</div>
}

</div>